import React, { useRef } from "react";

import { BaseTopNav } from "./components/base_topnav/index.jsx";
import { AccountLogo } from "./components/account_logo/index.jsx";
import { Help } from "./components/help/index.jsx";
import { UserProfile } from "./components/user_profile/index.jsx";

import styles from "./topnav.css";

export function MainTopnav() {
  const currentClosePopup = useRef(null);

  return (
    <BaseTopNav>
      <BaseTopNav.LeftRenderer>
        <AccountLogo />
      </BaseTopNav.LeftRenderer>
      <BaseTopNav.MiddleRenderer>
        <div className={styles.searchContainerWrapper}>
          <div id="searchnavcontainer" className={styles.searchContainer} />
        </div>
      </BaseTopNav.MiddleRenderer>
      <BaseTopNav.RightRenderer>
        <div className={styles.rightColumn}>
          <div id="notificationavcontainer" className={styles.notificationav} />
          <Help />
          <UserProfile currentClosePopup={currentClosePopup} />
        </div>
      </BaseTopNav.RightRenderer>
    </BaseTopNav>
  );
}
